import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const getRoles = (setRoles: Function, language: string) => {
  ApiService.get("roles")
    .then((response) => {
      setRoles(response.data.roles);
    })
    .catch((err) => {
      console.error("Error fetching roles:", err);
      alert(translate(language, "PAGES.PERMISSIONS_API_KEY.MODAL.ERRORS.GET_ROLES"));
    });
};

export const createPermissionsApiKey = (
  payload: any,
  language: string,
  setLoading: Function,
  successCallback?: Function
) => {
  setLoading(true);
  ApiService.post("api-keys", payload)
    .then((_) => {
      alert(translate(language, "PAGES.PERMISSIONS_API_KEY.MODAL.SUCCESS.CREATE_API_KEY"));
      successCallback?.();
    })
    .catch((err) => {
      console.error("Error creating permissions api key:", err);
      alert(translate(language, "PAGES.PERMISSIONS_API_KEY.MODAL.ERRORS.CREATE_API_KEY"));
    })
    .finally(() => {
      setLoading(false);
    });
};
